/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import Offer from './modules/offer-calendar'
_('offer-cal').nodes().map((el) => new Modal(el))

----------------------------------------------------------------------------
Attributes on trigger element:
----------------------------------------------------------------------------
data-behaviour="offer-cal"  - For setting up the click event

----------------------------------------------------------------------------
Attributes on target element:
----------------------------------------------------------------------------
data-element="offer-cal"        - To match the trigger data-behaviour
data-ocd="header-image"
data-ocd="product-image"
data-ocd="desc"
data-ocd="price"
data-ocd="reduced-price"
data-ocd="valid-text"

----------------------------------------------------------------------------
Other attributes
----------------------------------------------------------------------------
data-modal-focus     - first element focused on open

*/
import { _ } from '../utils'

export default function OfferCalendar(el) {
    const headerImage = el.dataset.headerImage
    const productImage = el.dataset.productImage
    const desc = el.dataset.desc
    const price = el.dataset.price
    const reducedPrice = el.dataset.reducedPrice
    const validText = el.dataset.validText
    const link = el.dataset.link
    const linkTarget = el.dataset.linkTarget
    const linkButtonText = el.dataset.linkButtonText

    const offerModal = _('offer-cal-content', 'element').node()
    const ocdHeaderImage = _('header-image','ocd').nodeFrom(offerModal)
    const ocdProductImage =  _('product-image','ocd').nodeFrom(offerModal)
    const ocdDesc = _('desc','ocd').nodeFrom(offerModal)
    const ocdPrice = _('price','ocd').nodeFrom(offerModal)
    const ocdReducedPrice = _('reduced-price','ocd').nodeFrom(offerModal)
    const ocdValidText = _('valid-text','ocd').nodeFrom(offerModal)
    const ocdLink = _('link','ocd').nodeFrom(offerModal)

    const updateModalContent = () => {
        ocdHeaderImage.src = headerImage
        ocdProductImage.src = productImage
        ocdDesc.innerHTML = desc
        ocdPrice.innerHTML = price
        ocdReducedPrice.innerHTML = reducedPrice
        ocdValidText.innerHTML = validText
        ocdLink.setAttribute('href', link)
        ocdLink.setAttribute('target', linkTarget)
        ocdLink.innerHTML = linkButtonText
    }

    el.addEventListener('mousedown', () => {
        updateModalContent()
    })

    el.addEventListener('touchstart', () => {
        updateModalContent()
    })
}

